import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageSEO from '@/components/PageSEO';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <PageSEO
        title="Datenschutzerklärung | Handwerkernotdienst NRW"
        description="Datenschutzerklärung der Handwerkernotdienst NRW. Informationen zum Umgang mit personenbezogenen Daten gemäß DSGVO."
        canonicalUrl="https://handwerkernotdienst.nrw/datenschutz"
        breadcrumbs={[
          { name: 'Start', url: 'https://handwerkernotdienst.nrw/' },
          { name: 'Datenschutz', url: 'https://handwerkernotdienst.nrw/datenschutz' }
        ]}
      />
      
      <Header />

      <section className="py-16" data-testid="datenschutz-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-testid="datenschutz-title">Datenschutzerklärung</h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-xl font-bold text-gray-900 mb-3">Allgemeine Hinweise</h3>
            <p className="text-gray-700 mb-6">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
              wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Datenerfassung auf dieser Website</h3>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p className="text-gray-700 mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem 
              <Link to="/impressum" className="text-[#0066cc] hover:underline"> Impressum</Link> dieser Website entnehmen.
            </p>

            <h4 className="text-lg font-semibold text-gray-900 mb-2">Wie erfassen wir Ihre Daten?</h4>
            <p className="text-gray-700 mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, 
              die Sie in ein Kontaktformular eingeben.
            </p>
            <p className="text-gray-700 mb-6">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. 
              Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>

            <h4 className="text-lg font-semibold text-gray-900 mb-2">Wofür nutzen wir Ihre Daten?</h4>
            <p className="text-gray-700 mb-6">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>

            <h4 className="text-lg font-semibold text-gray-900 mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p className="text-gray-700 mb-6">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen 
              Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. 
              Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">2. Hosting und Content Delivery Networks (CDN)</h2>
            <p className="text-gray-700 mb-6">
              Diese Website wird auf externen Servern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
              werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, 
              Meta- und Kommunikationsdaten handeln.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="text-xl font-bold text-gray-900 mb-3">Datenschutz</h3>
            <p className="text-gray-700 mb-6">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten 
              vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p className="text-gray-700 mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="text-gray-700 mb-6">
              Schössow Dienstleistungen UG (haftungsbeschränkt)<br />
              Andreas Schoessow<br />
              Neben dem Brand 10<br />
              44135 Dortmund<br />
              <br />
              Telefon: <a href="tel:+4923139083687" className="text-[#0066cc] hover:underline">+49 231 39083687</a><br />
              E-Mail: <a href="mailto:info@handwerkernotdienst.nrw" className="text-[#0066cc] hover:underline">info@handwerkernotdienst.nrw</a>
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Speicherdauer</h3>
            <p className="text-gray-700 mb-6">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten 
              bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine 
              Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe 
              für die Speicherung Ihrer personenbezogenen Daten haben.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="text-gray-700 mb-6">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte 
              Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Auskunft, Löschung und Berichtigung</h3>
            <p className="text-gray-700 mb-6">
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre 
              gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht 
              auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie 
              sich jederzeit an uns wenden.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">4. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-xl font-bold text-gray-900 mb-3">Kontaktformular</h3>
            <p className="text-gray-700 mb-6">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen 
              dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
              Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Anfrage per E-Mail, Telefon oder Telefax</h3>
            <p className="text-gray-700 mb-6">
              Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden 
              personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. 
              Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">5. Ihre Rechte</h2>
            <p className="text-gray-700 mb-4">
              Sie haben folgende Rechte:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
              <li>Recht auf Auskunft über Ihre gespeicherten Daten</li>
              <li>Recht auf Berichtigung unrichtiger Daten</li>
              <li>Recht auf Löschung Ihrer Daten</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Datenübertragbarkeit</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung</li>
              <li>Recht auf Beschwerde bei einer Aufsichtsbehörde</li>
            </ul>

            <p className="text-gray-700 mb-6">
              Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an: 
              <a href="mailto:info@handwerkernotdienst.nrw" className="text-[#0066cc] hover:underline">info@handwerkernotdienst.nrw</a>
            </p>

            <p className="text-gray-600 text-sm mt-8">
              Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DatenschutzPage;
